/**
 * Search overlay with predictive results, rendered by the
 * predictive-search section as the visitor types.
 */
(function () {
  var overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;
  var input = overlay.querySelector('[data-search-input]');
  var results = overlay.querySelector('[data-search-results]');
  var timer;
  var lastFocus;

  function open() {
    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 50);
  }

  function close() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-search-open]')) {
      event.preventDefault();
      open();
    } else if (event.target.closest('[data-search-close]')) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < 2) {
      results.innerHTML = '';
      return;
    }
    timer = setTimeout(function () {
      var url = '/search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (input.value.trim() !== q) return;
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var section = parsed.querySelector('#shopify-section-predictive-search') || parsed.body;
          results.innerHTML = section.innerHTML;
        })
        .catch(function () {});
    }, 250);
  });
})();
